@if (phaseMatrix$ | async; as phaseMatrix) {
	@if (phaseMatrix.program; as program) {
		@if (program.phases; as programPhases) {
			<stages-fit-to-page [fitToPage]="fitToPage">
				<table class="phaseOverview">
					<tr>
						<td class="program"></td>
						@for (item of [].constructor(phaseMatrix.program.duration); track item; let i = $index) {
							<td>
								<div class="phase dummy"></div>
							</td>
						}
					</tr>
					<tr>
						<td class="program">
							@if (showUpdateButton) {
								<div class="ws-name">
									@if (program.hasErrors) {
										<div class="action">
											<button
												[attr.aria-label]="'error' | translate"
												[attr.title]="'error' | translate"
												(click)="openPopup(program.getJobProgressRoute())"
											>
												<i class="ico ico-warning error-color"></i>
											</button>
										</div>
									}
									<button
										class="action"
										[disabled]="program.isDisabled()"
										(click)="openPopup(phaseMatrix.getUpdateConsiderFrozenAllRoute())"
									>
										@if (!program.inProgress) {
											<i [ngClass]="phaseMatrix.getIconClasses()"></i>
										}
										@if (program.inProgress) {
											<a (click)="openPopup(program.getJobProgressRoute())">
												<stages-spin></stages-spin>
											</a>
										}
									</button>
								</div>
							}
						</td>
						@for (phaseAdapter of program.phases; track getPhaseId($index, phaseAdapter)) {
							<ng-container
								*ngTemplateOutlet="phaseCard; context: { $implicit: phaseAdapter, processAdapter: program }"
							></ng-container>
						}
					</tr>
					@for (process of phaseMatrix.projects; track getProcessId($index, process)) {
						<tr>
							<td>
								<div class="ws-name">
									<a [routerLink]="process.getRouterLink()" title="{{ $any(process.process).workspaceName }}">
										<span class="span2">{{ $any(process.process).workspaceName }}</span>
									</a>
									@if (process.hasErrors && showUpdateButton) {
										<div class="action">
											<button
												[attr.aria-label]="'error' | translate"
												[attr.title]="'error' | translate"
												(click)="openPopup(process.getJobProgressRoute())"
											>
												<i class="ico ico-warning error-color"></i>
											</button>
										</div>
									}
									@if (showUpdateButton) {
										<button
											class="action"
											[disabled]="process.isDisabled()"
											(click)="openPopup(process.getUpdateConsiderFrozenRoute())"
										>
											@if (!process.inProgress) {
												<i [ngClass]="process.getIconClasses()"></i>
											}
											@if (process.inProgress) {
												<a (click)="openPopup(process.getJobProgressRoute())">
													<stages-spin></stages-spin>
												</a>
											}
										</button>
									}
								</div>
							</td>
							@for (phaseAdapter of process.phases; track getPhaseId($index, phaseAdapter)) {
								<ng-container
									*ngTemplateOutlet="phaseCard; context: { $implicit: phaseAdapter, processAdapter: process }"
								></ng-container>
							}
							@for (phaseAdapter of program.phases; track getPhaseId(i, phaseAdapter); let i = $index) {
								@if (i >= process.duration) {
									<td [attr.colspan]="1">
										<div class="wrapper"></div>
									</td>
								}
							}
						</tr>
					}
				</table>
			</stages-fit-to-page>
		}
	}
}

<ng-template #phaseCard let-phaseAdapter let-processAdapter="processAdapter">
	<td [attr.colspan]="phaseAdapter.duration">
		<div class="phase" [ngClass]="phaseAdapter.getFreezeStateClasses()">
			<a [routerLink]="phaseAdapter.getRouterLink()" title="{{ phaseAdapter.phase.label }}">
				<span [ngClass]="phaseAdapter.getLabelClasses()" class="span2">{{ phaseAdapter.phase.label }}</span>
			</a>
			@if (phaseAdapter.hasErrors) {
				<div class="action">
					<button
						[attr.aria-label]="'error' | translate"
						[attr.title]="'error' | translate"
						(click)="openPopup(phaseAdapter.getJobProgressRoute())"
					>
						<i class="ico ico-warning error-color"></i>
					</button>
				</div>
			}
			<button
				class="action"
				[disabled]="phaseAdapter.isDisabled() || processAdapter.isDisabled()"
				(click)="openPopup(phaseAdapter.getStartFreezeRoute())"
			>
				@if (!phaseAdapter.inProgress) {
					<i [ngClass]="getIconClasses(phaseAdapter)"></i>
				}
				@if (phaseAdapter.inProgress) {
					<a (click)="openPopup(phaseAdapter.getJobProgressRoute())">
						<stages-spin></stages-spin>
					</a>
				}
			</button>
		</div>
	</td>
</ng-template>
